// prod config variable template
// to use production config rename this file to config.js
module.exports.IS_DEV = false;
module.exports.BACKEND_URL = 'https://traitors.sh';
